/**
 * Key dùng để phân biệt tour guide
 */
export const TourGuideKey = {
  /**
   * Màn tổng quan
   */
  Dashboard: 'Dashboard',

  /**
   * Người dùng vài trò
   */
  UserList: 'UserList',

  /**
   * Thêm người dùng
   */
  AddUser: 'AddUser',

  Step1ImportUser: 'Step1ImportUser',
  Step2ImportUser: 'Step2ImportUser',
  Step3ImportUser: 'Step3ImportUser',
  LiveChat: 'LiveChat',

}

/**
 * Key dùng để lưu vào bảng user option
 */
export const OptionKey = 'tour-guide';